import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { polishExtendedNameRegex } from 'src/shared/regex';

export const groupNameRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    required: true,
    message: t('Please enter correct group name'),
    pattern: polishExtendedNameRegex,
  });
};
